export default "__VITE_ASSET__DZqVnPm7__"